<template>
	<ul v-if="items">
		<template v-for="(item, i) of items">
			<li v-if="visible(item) && !item.separator" :key="item.label || i"
				:class="[{ 'layout-menuitem-category': root, 'active-menuitem': activeIndex === i && !item.to && !item.disabled }]"
				role="none">
				<template v-if="root">
					<div class="layout-menuitem-root-text" :aria-label="item.label">{{ item.label }}</div>
					<appsubmenu :items="visible(item) && item.items" @menuitem-click="$emit('menuitem-click', $event)">
					</appsubmenu>
				</template>
				<template v-else>
					<router-link v-if="filterMenuAnimal(item.to)" :to="item.to"
						:class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]" :style="item.style"
						@click="onMenuItemClick($event, item, i)" :target="item.target" :aria-label="item.label" exact
						role="menuitem" v-ripple>
						<i :class="item.icon"></i>
						<span>{{ item.label }}</span>
						<i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
						<Badge v-if="item.badge" :value="item.badge"></Badge>
					</router-link>
					<a v-if="!item.to" :href="item.url || '#'" :style="item.style"
						:class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
						@click="onMenuItemClick($event, item, i)" :target="item.target" :aria-label="item.label"
						role="menuitem" v-ripple>
						<i :class="item.icon"></i>
						<span>{{ item.label }}</span>
						<i v-if="item.items" class="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>
						<Badge v-if="item.badge" :value="item.badge"></Badge>
					</a>
					<transition name="layout-submenu-wrapper">
						<appsubmenu v-show="activeIndex === i" :items="visible(item) && item.items"
							@menuitem-click="$emit('menuitem-click', $event)"></appsubmenu>
					</transition>
				</template>
			</li>
			<li class="p-menu-separator" :style="item.style" v-if="visible(item) && item.separator"
				:key="'separator' + i" role="separator"></li>
		</template>
	</ul>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'appsubmenu',
	props: {
		items: Array,
		root: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeIndex: null,
		}
	},
	computed: {
		...mapGetters({
			animal_id: 'animal_id',
		}),
	},
	methods: {
		filterMenuAnimal(item) {
			if (item === '/project/thaiblack') {
				if (this.animal_id === "1") {
					return true
				}
				return false;
			} else if (item === '/project/redgoat') {
				if (this.animal_id === "3") {
					return true
				}
				return false;
			}
			else {
				return item;
			}
		},
		onMenuItemClick(event, item, index) {
			if (item.disabled) {
				event.preventDefault();
				return;
			}

			if (!item.to && !item.url) {
				event.preventDefault();
			}

			//execute command
			if (item.command) {
				item.command({ originalEvent: event, item: item });
			}

			this.activeIndex = index === this.activeIndex ? null : index;

			this.$emit('menuitem-click', {
				originalEvent: event,
				item: item
			});
		},
		visible(item) {
			let isVisible = (typeof item.visible === 'function' ? item.visible() : item.visible !== false);
			if (isVisible && item.menuId) {
				const user = this.$store.state.user;
				if (user && user.GroupID !== 1) {
					const permissions = this.$store.state.permission;
					const perm = permissions.find(p => p.MenuID === item.menuId);
					if (perm && perm.IsPreview === 0) {
						isVisible = false;
					}
				}
			}
			return isVisible;
		}
	}
}
</script>
